import { FC } from 'react'
import PerFlexRow from '../../FlexRow'
import PerText from '../../Text'

import '../index.less'
import { Colors } from '../../../util/types'
import { PerTag } from '../../Tag'

type Props = {
  number: number
  name: string
  color?: 'blue' | 'purple' | 'cyan' | 'green' | 'magenta' | 'pink' | 'red' | 'orange' | 'yellow' | 'volcano' | 'geekblue' | 'lime' | 'gold'
  outOf?: string
  numberColor?: Colors
}

export const PerInfoBoxTagElement: FC<Props> = ({ number, name, color, outOf, numberColor }) => {
  return (
    <PerFlexRow align="middle" justify="center" direction="column" className="per-infoBox--tagElement">
      <PerTag color={color}>{name}</PerTag>
      <PerText mt="xs" fontSize="l" color={numberColor} className="whiteSpace--nowrap">
        {number}
        {outOf && (
          <PerText appearance="label-small" display="inline" ml="xxxs">
            / {outOf}
          </PerText>
        )}
      </PerText>
    </PerFlexRow>
  )
}
